import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1,
  class: "text-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_watch_video = _resolveComponent("watch-video");
  const _component_b_spinner = _resolveComponent("b-spinner");
  return _openBlock(), _createElementBlock("div", null, [_ctx.video && !_ctx.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_watch_video, {
    video: _ctx.video
  }, null, 8, ["video"])])) : _createCommentVNode("", true), _ctx.loading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_b_spinner), _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)), _cache[1] || (_cache[1] = _createTextVNode("Loading Videos", -1)), _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)), _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1))])) : _createCommentVNode("", true)]);
}